import type { RosterUserRecord, RosterTableRowRecord } from '../types';
import { roleColumnDataIndex } from './util';

/**
 * The sorting function for role: sorts based on role priority
 */
const roleSorter = (
  a: RosterTableRowRecord & RosterUserRecord,
  b: RosterTableRowRecord & RosterUserRecord
) => a.rolePriority - b.rolePriority;

/**
 * Returns the sorter function that should be applied to the given data index
 */
const sorters = (dataIndex: string) =>
  dataIndex === roleColumnDataIndex
    ? { compare: roleSorter, multiple: 1 }
    : undefined;

export default sorters;
